import React, { useEffect, useState, useRef } from "react";
import Home from "pages/Home";
import About from "pages/About";
import Design from "pages/Design";
import { useAppContext } from "lib/state/TextProvider";
import { getUserProfile } from "lib/api";
import { EntryType, ColorTheme } from "lib/models";
import { Routes, Route, Navigate } from "react-router-dom";
import SignInModal from "pages/SignInModal";
import SignUpModal from "pages/SignUpModal";
import { PageRoute } from "constants/paths";

const ReroutingHomePage = () => {
  const { state, setWorkspaceNavigation } = useAppContext();
  const [rootUuid, setRootUuid] = useState<string | null>(null);

  useEffect(() => {
    if (state.userProfile) {
      setRootUuid(state.userProfile.rootWorkspaceUuid);
      setWorkspaceNavigation([]);
    }
  }, [state.userProfile]);

  if (!rootUuid) {
    return null;
  }

  return <Navigate to={`/${EntryType.WORKSPACE}/${rootUuid}`} />;
};

const App: React.FC = () => {
  const { state, setUserProfile, setUserProfileNeedsReload } = useAppContext();
  const hasLoadedProfile = useRef(false);

  useEffect(() => {
    const loadUserProfile = async () => {
      if (hasLoadedProfile.current && !state.userProfileNeedsReload) return;
      const userProfile = await getUserProfile();
      setUserProfile(userProfile);
      setUserProfileNeedsReload(false);
      hasLoadedProfile.current = true;
    };
    loadUserProfile();
  }, [state.userProfileNeedsReload]);

  useEffect(() => {
    const colorTheme: ColorTheme = state.userProfile?.colorTheme || "default";
    document.documentElement.setAttribute("data-theme", colorTheme);
  }, [state.userProfile?.colorTheme]);

  return (
    <>
      <Routes>
        <Route path="/" element={<ReroutingHomePage />} />
        <Route path={PageRoute.ABOUT} element={<About />} />
        <Route path={PageRoute.DESIGN} element={<Design />} />
        <Route
          path="/:entryType/:entryUuid/refs/:refsPath"
          element={<Home />}
        />
        <Route path="/:entryType/:entryUuid" element={<Home />} />
        <Route path={PageRoute.SIGN_IN} element={<SignInModal />} />
        <Route path={PageRoute.SIGN_UP} element={<SignUpModal />} />
      </Routes>
    </>
  );
};

export default App;
